import { call, throttle, put } from 'redux-saga/effects';
import * as getFieldsActions from '../actions/getFieldsActions';
import {
  getAdvertisingsRequest,
  getAppliancesRequest,
  getBrandsRequest,
  getModelsRequest,
  getCategoriesRequest,
  getColorsRequest,
  getVehicleTypesRequest,
  getConditionersRequest,
  getDriveTypesRequest,
  getEngineTypesRequest,
  getEntertainmentsRequest,
  getFacilitiesRequest,
  getFunctionsRequest,
  getInteriorsRequest,
  getSeatMaterialsRequest,
  getTachographsRequest,
  getTintsRequest,
  getTransfersRequest,
  getParkingRequest,
  getSteeringArrangementRequest,
  getDriveUnitTypesRequest,
} from '../../api/vehicles/getFieldsRequests';

function* getFunctionsTypesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getFunctionsRequest, payload);
    yield put(getFieldsActions.getFunctionsTypesSuccess(response));
  } catch (error) {
    yield put(getFieldsActions.getFunctionsTypesError(error));
  }
}

function* getTransfersTypesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getTransfersRequest, payload);
    yield put(getFieldsActions.getTransfersTypesSuccess(response));
  } catch (error) {
    yield put(getFieldsActions.getTransfersTypesError(error));
  }
}

function* getAppliancesTypesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getAppliancesRequest, payload);
    yield put(getFieldsActions.getAppliancesTypesSuccess(response));
  } catch (error) {
    yield put(getFieldsActions.getAppliancesTypesError(error));
  }
}

function* getSeatMaterialsTypesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getSeatMaterialsRequest, payload);
    yield put(getFieldsActions.getSeatMaterialsTypesSuccess(response));
  } catch (error) {
    yield put(getFieldsActions.getSeatMaterialsTypesError(error));
  }
}

function* getTintsTypesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getTintsRequest, payload);
    yield put(getFieldsActions.getTintsTypesSuccess(response));
  } catch (error) {
    yield put(getFieldsActions.getTintsTypesError(error));
  }
}

function* getAdvertisingsTypesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getAdvertisingsRequest, payload);
    yield put(getFieldsActions.getAdvertisingsTypesSuccess(response));
  } catch (error) {
    yield put(getFieldsActions.getAdvertisingsTypesError(error));
  }
}

function* getInteriorsTypesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getInteriorsRequest, payload);
    yield put(getFieldsActions.getInteriorsTypesSuccess(response));
  } catch (error) {
    yield put(getFieldsActions.getInteriorsTypesError(error));
  }
}

function* getFacilitiesTypesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getFacilitiesRequest, payload);
    yield put(getFieldsActions.getFacilitiesTypesSuccess(response));
  } catch (error) {
    yield put(getFieldsActions.getFacilitiesTypesError(error));
  }
}

function* getTachographsTypesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getTachographsRequest, payload);
    yield put(getFieldsActions.getTachographsTypesSuccess(response));
  } catch (error) {
    yield put(getFieldsActions.getTachographsTypesError(error));
  }
}

function* getBrandsTypesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getBrandsRequest, payload);
    yield put(getFieldsActions.getBrandsTypesSuccess(response));
  } catch (error) {
    yield put(getFieldsActions.getBrandsTypesError(error));
  }
}

function* getModelsTypesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getModelsRequest, payload);
    yield put(getFieldsActions.getModelsTypesSuccess(response));
  } catch (error) {
    yield put(getFieldsActions.getModelsTypesError(error));
  }
}

function* getColorsTypesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getColorsRequest, payload);
    yield put(getFieldsActions.getColorsTypesSuccess(response));
  } catch (error) {
    yield put(getFieldsActions.getColorsTypesError(error));
  }
}

function* getVehicleTypesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getVehicleTypesRequest, payload);
    yield put(getFieldsActions.getVehicleTypesSuccess(response));
  } catch (error) {
    yield put(getFieldsActions.getVehicleTypesError(error));
  }
}

function* getConditionersTypesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getConditionersRequest, payload);
    yield put(getFieldsActions.getConditionersTypesSuccess(response));
  } catch (error) {
    yield put(getFieldsActions.getConditionersTypesError(error));
  }
}

function* getCategoriesTypesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getCategoriesRequest, payload);
    yield put(getFieldsActions.getCategoriesTypesSuccess(response));
  } catch (error) {
    yield put(getFieldsActions.getCategoriesTypesError(error));
  }
}

function* getDriveTypesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getDriveTypesRequest, payload);
    yield put(getFieldsActions.getDriveTypesSuccess(response));
  } catch (error) {
    yield put(getFieldsActions.getDriveTypesError(error));
  }
}

function* getEngineTypesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getEngineTypesRequest, payload);
    yield put(getFieldsActions.getEngineTypesSuccess(response));
  } catch (error) {
    yield put(getFieldsActions.getEngineTypesError(error));
  }
}

function* getEntertainmentsTypesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getEntertainmentsRequest, payload);
    yield put(getFieldsActions.getEntertainmentsTypesSuccess(response));
  } catch (error) {
    yield put(getFieldsActions.getEntertainmentsTypesError(error));
  }
}
function* getParkingTypesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getParkingRequest, payload);
    yield put(getFieldsActions.getParkingTypesSuccess(response));
  } catch (error) {
    yield put(getFieldsActions.getParkingTypesError(error));
  }
}

function* getSteeringArrangementTypesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getSteeringArrangementRequest, payload);
    yield put(getFieldsActions.getSteeringArrangementTypesSuccess(response));
  } catch (error) {
    yield put(getFieldsActions.getSteeringArrangementTypesError(error));
  }
}

function* getDriveUnitTypesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getDriveUnitTypesRequest, payload);
    yield put(getFieldsActions.getDriveUnitTypesSuccess(response));
  } catch (error) {
    yield put(getFieldsActions.getDriveUnitTypesError(error));
  }
}

// todo разобраться зачем сделали такую последовательность throttle
export function* getFieldsWatcher() {
  yield throttle(
    1000,
    getFieldsActions.getBrandsTypes.toString(),
    getBrandsTypesSaga
  );
  yield throttle(
    1000,
    getFieldsActions.getColorsTypes.toString(),
    getColorsTypesSaga
  );
  yield throttle(
    1000,
    getFieldsActions.getVehicleTypes.toString(),
    getVehicleTypesSaga
  );
  yield throttle(
    1000,
    getFieldsActions.getConditionersTypes.toString(),
    getConditionersTypesSaga
  );
  yield throttle(
    100,
    getFieldsActions.getCategoriesTypes.toString(),
    getCategoriesTypesSaga
  );
  yield throttle(
    1000,
    getFieldsActions.getDriveTypes.toString(),
    getDriveTypesSaga
  );
  yield throttle(
    1000,
    getFieldsActions.getEngineTypes.toString(),
    getEngineTypesSaga
  );
  yield throttle(
    1000,
    getFieldsActions.getEntertainmentsTypes.toString(),
    getEntertainmentsTypesSaga
  );
  yield throttle(
    100,
    getFieldsActions.getModelsTypes.toString(),
    getModelsTypesSaga
  );
  yield throttle(
    1000,
    getFieldsActions.getTachographsTypes.toString(),
    getTachographsTypesSaga
  );
  yield throttle(
    1000,
    getFieldsActions.getFacilitiesTypes.toString(),
    getFacilitiesTypesSaga
  );
  yield throttle(
    1000,
    getFieldsActions.getInteriorsTypes.toString(),
    getInteriorsTypesSaga
  );
  yield throttle(
    1000,
    getFieldsActions.getTransfersTypes.toString(),
    getTransfersTypesSaga
  );
  yield throttle(
    1000,
    getFieldsActions.getTintsTypes.toString(),
    getTintsTypesSaga
  );
  yield throttle(
    1000,
    getFieldsActions.getAdvertisingsTypes.toString(),
    getAdvertisingsTypesSaga
  );
  yield throttle(
    1000,
    getFieldsActions.getSeatMaterialsTypes.toString(),
    getSeatMaterialsTypesSaga
  );
  yield throttle(
    1000,
    getFieldsActions.getAppliancesTypes.toString(),
    getAppliancesTypesSaga
  );
  yield throttle(
    1000,
    getFieldsActions.getFunctionsTypes.toString(),
    getFunctionsTypesSaga
  );
  yield throttle(
    1000,
    getFieldsActions.getParkingTypes.toString(),
    getParkingTypesSaga
  );
  yield throttle(
    1000,
    getFieldsActions.getFacilitiesTypes.toString(),
    getFacilitiesTypesSaga
  );
  yield throttle(
    1000,
    getFieldsActions.getInteriorsTypes.toString(),
    getInteriorsTypesSaga
  );
  yield throttle(
    1000,
    getFieldsActions.getSteeringArrangementTypes.toString(),
    getSteeringArrangementTypesSaga
  );
  yield throttle(
    1000,
    getFieldsActions.getDriveUnitTypes.toString(),
    getDriveUnitTypesSaga
  );
}
